export default class FiltroLeadFrotaDTO {
  dataInicio?: string;
  dataFim?: string;

  constructor(
    dataInicio?: string,
    dataFim?: string
  ) {
    this.dataInicio = dataInicio;
    this.dataFim = dataFim;
  }
}